import { gql } from "@apollo/client";

const GET_ESQUEMA_CONEXIONES = gql`
    query conexionDiasByIdEvaluacion($idEvaluacion: Int!) {
        conexionDiasByIdEvaluacion(idEvaluacion: $idEvaluacion) {
            idDia
        }
    }
`;

export default GET_ESQUEMA_CONEXIONES;

export const adaptEsquemaConexiones = (dias) => {
  return structuredClone(dias).map((dia) => dia.idDia);
};